<template>
    <BreadCrumb PageTitle="Liste des catégories d'offres" />
    <ListeCategorieOffre />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeCategorieOffre from "../../components/CategorieOffre/ListeCategorieOffre.vue";

  
    export default defineComponent({
      name: "ListeCategorieOffrePage",
      components: {
        BreadCrumb,
        ListeCategorieOffre,
      },
    });
  </script>